import React from 'react'

export const useFrame = frame => {
  return React.useMemo(() => {
    if (frame) {
      return frame
    }
    return {
      document: typeof document !== 'undefined' ? document : undefined,
      window: typeof window !== 'undefined' ? window : undefined
    }
  }, [frame])
}
